var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10736_100842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.25049H12.75C12.336 5.25049 12 5.58649 12 6.00049C12 6.41449 12.336 6.75049 12.75 6.75049H21.0645L16.4565 10.334L13.152 8.23249L12.348 9.49849L16.098 11.8835C16.2195 11.9615 16.3605 12.0005 16.5 12.0005C16.662 12.0005 16.8255 11.948 16.9605 11.843L22.5 7.53349V17.2505H12.75C12.336 17.2505 12 17.5865 12 18.0005C12 18.4145 12.336 18.7505 12.75 18.7505H23.25C23.664 18.7505 24 18.4145 24 18.0005V6.00049C24 5.58649 23.664 5.25049 23.25 5.25049Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2285 0.923022C13.0575 0.780522 12.828 0.719022 12.612 0.764022L0.612 3.01402C0.2565 3.08002 0 3.38902 0 3.75052V20.2505C0 20.6105 0.2565 20.921 0.612 20.987L12.612 23.237C12.657 23.246 12.7035 23.2505 12.75 23.2505C12.924 23.2505 13.0935 23.1905 13.2285 23.078C13.401 22.9355 13.5 22.7225 13.5 22.5005V1.50052C13.5 1.27702 13.401 1.06552 13.2285 0.923022Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 17.2505C4.683 17.2505 3 15.2315 3 12.7505C3 10.2695 4.683 8.25049 6.75 8.25049C8.817 8.25049 10.5 10.2695 10.5 12.7505C10.5 15.2315 8.817 17.2505 6.75 17.2505ZM6.75 9.75049C5.5095 9.75049 4.5 11.096 4.5 12.7505C4.5 14.405 5.5095 15.7505 6.75 15.7505C7.9905 15.7505 9 14.405 9 12.7505C9 11.096 7.9905 9.75049 6.75 9.75049Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10736_100842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.c2f96dadc39b66e11cb0378a0da1bc54.svg";
export { ForwardRef as ReactComponent };